import axiosInstance from "./utils";
import store from "../store";

export default {
  getAttributes(clientId) {
    return axiosInstance
      .get(`attributes/${clientId}`)
      .then((response) => response.data)
      .catch((err) => {
        console.error("Error on get attributes", err);
        store.dispatch("add_error_queue", {
          error: err,
          message: "Une erreur est survenu lors de l'obtention des attributs",
        });
      });
  },

  createAttributes(clientId, data) {
    return axiosInstance
      .post(`attributes/${clientId}`, data)
      .then((response) => response.data)
      .catch((err) => {
        console.error("Error on create attribute", err);
        store.dispatch("add_error_queue", {
          error: err,
          message: "Une erreur est survenu lors de la création de l' attribut",
        });
      });
  },

  updateAttributes(clientId, data) {
    return axiosInstance
      .put(`attributes/${clientId}/${data.id}`, data)
      .then((response) => response.data)
      .catch((err) => {
        console.error("Error on update attribute", err);
        store.dispatch("add_error_queue", {
          error: err,
          message:
            "Une erreur est survenu lors de la mise à jour de l' attribut",
        });
      });
  },

  deleteAttributes(clientId, attrId) {
    return axiosInstance
      .delete(`attributes/${clientId}/${attrId}`)
      .then((response) => response.data)
      .catch((err) => {
        console.error("Error on create attribute", err);
        store.dispatch("add_error_queue", {
          error: err,
          message:
            "Une erreur est survenu lors de la suppression de l' attribut",
        });
      });
  },
};
